import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-decider',
  templateUrl: './decider.component.html',
  styleUrls: ['./decider.component.scss']
})
export class DeciderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
